import React, { FC } from 'react';
import { Grid } from '@material-ui/core';
import SummaryLabelTitle from '../../../summaryLabel/SummaryLabelTitle';
import PriceValue from '../priceValue/PriceValue';
import summaryLabelStyles from '../../../summaryLabel/SummaryLabelStyles';
import { PriceDisplayType } from '../../../../../../../../../../common/enum/PriceDisplayType';
import { GetCustomizeCar_customizeCar_prices_carPrice_originalPrice } from '../../../../../../../graphql/queries/__generated__/GetCustomizeCar';
import { NewPriceType } from '../../../../../../../service/carConfigurationService';
import useFilterSelectedCurrencyPrice from '../../../../../../../../gqlCommon/hooks/currency/useFilterSelectedCurrencyPrice';

export interface IOriginalPriceProps {
  label: string | JSX.Element;
  prices: GetCustomizeCar_customizeCar_prices_carPrice_originalPrice[];
  currency: string;
  loading?: boolean;
  isComplexModel?: boolean;
  labelClassNames?: string;
  taxLabel?: string;
  summaryShowTaxes?: boolean;
}

const SummaryOriginalPrice: FC<IOriginalPriceProps> = ({
  currency,
  prices,
  loading,
  isComplexModel,
  label,
  labelClassNames,
  taxLabel,
  summaryShowTaxes,
}) => {
  const styles = summaryLabelStyles();

  const netPrices = prices.filter(({ type }) => type === NewPriceType.NET_PRICE);
  const filterKey = summaryShowTaxes && netPrices.length > 0 ? NewPriceType.NET_PRICE : NewPriceType.FINAL_PRICE;

  const price = useFilterSelectedCurrencyPrice(prices.filter(price => price.type === filterKey));

  return (
    <Grid
      container={true}
      justifyContent={'space-between'}
      spacing={3}
      className={styles.lineContainer}
      classes={{ root: styles.container }}
    >
      <SummaryLabelTitle
        label={label}
        boldLabel={isComplexModel}
        labelClassNames={labelClassNames}
        colSm={8}
        colXs={6}
      />
      <PriceValue
        loading={loading}
        price={price}
        priceType={PriceDisplayType.PRIMARY}
        currency={currency}
        boldPrice={true}
        testId={'basePrice'}
        taxLabel={taxLabel}
      />
    </Grid>
  );
};

export default SummaryOriginalPrice;
